import { render, staticRenderFns } from "./address-picker.vue?vue&type=template&id=7b57699b&scoped=true&"
import script from "./address-picker.vue?vue&type=script&lang=js&"
export * from "./address-picker.vue?vue&type=script&lang=js&"
import style0 from "./address-picker.vue?vue&type=style&index=0&id=7b57699b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b57699b",
  null
  
)

export default component.exports